import React, {useState} from "react";

export const LoadingSpinner = ({theme = 'dark'}) => {

    return (
        <div
            className={`loader-container-app ${theme === 'dark' ? 'loader-container-dark-theme' : 'loader-container-light-theme'}`}>
            <div className="loader-app"/>
        </div>
    );
};